import storeEvent from '../../utils/store-event';
import { getTabIdx, tabNames } from '../../utils/tab-helpers';
import { sendCategoryFilterEvent } from '../../utils/event-triggers';

export default {
    onCreate() {
        this.mainClass = 'str-categories';
        this.takeoverClass = `${this.mainClass}__takeover`;
        this.shopTabIdx = getTabIdx(tabNames.SHOP);
        this.state = {
            open: false,
            focusDisabled: true
        };
    },
    onMount() {
        this.body = document.querySelector('body');
        storeEvent.openMobileCatLayer.listen(() => {
            this.openCategories();
        });
    },
    openCategories: function() {
        this.state.open = true;
        this.body.classList.add(this.takeoverClass);
    },
    closeCategories: function() {
        this.state.open = false;
        this.body.classList.remove(this.takeoverClass);
    },
    fetchCategoryListings: function(url, evt) {
        evt.originalEvent.preventDefault();
        storeEvent.changeToTab.dispatch({
            tabIndex: this.shopTabIdx,
            skipFocus: true
        });
        setTimeout(() => {
            sendCategoryFilterEvent({
                url: url,
                clickEvent: evt
            });
            this.closeCategories();
        }, 0);
    }
};
